import { render, staticRenderFns } from "./activities-details.vue?vue&type=template&id=6803ecd0"
import script from "./activities-details.vue?vue&type=script&lang=js"
export * from "./activities-details.vue?vue&type=script&lang=js"
import style0 from "./activities-details.vue?vue&type=style&index=0&id=6803ecd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports